export default function HoverBubble({ children, content }) {
	return <div className="hover-bubble">
		{content != null && (!Array.isArray(content) || content.length > 0) && <div className="tooltip tooltip-top">
			{content}
		</div>}
		<div className="hover-bubble-children">
			{children}
		</div>
	</div>;
}